import React from 'react';
import { Link } from 'react-router-dom';
import { HelpCircleIcon, FileTextIcon, MessageCircleIcon, PhoneIcon, ClockIcon, ShieldIcon, HeartIcon, AlertCircleIcon } from 'lucide-react';
const Help = () => {
  return <div className="bg-amber-50 min-h-screen py-12" data-id="element-1242">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1243">
        <div className="mb-8" data-id="element-1244">
          <Link to="/" className="text-amber-800 hover:text-amber-900 flex items-center" data-id="element-1245">
            <svg className="h-5 w-5 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-1246">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" data-id="element-1247"></path>
            </svg>
            Back to Home
          </Link>
        </div>
        <div className="bg-white shadow rounded-lg overflow-hidden" data-id="element-1248">
          <div className="px-6 py-8 border-b border-gray-200 bg-amber-800 text-white" data-id="element-1249">
            <h1 className="text-3xl font-bold mb-2" data-id="element-1250">Help Center</h1>
            <p className="text-amber-100" data-id="element-1251">
              Find solutions, guides, and answers to common questions
            </p>
          </div>
          <div className="p-6" data-id="element-1252">
            <div className="mb-12" data-id="element-1253">
              <h2 className="text-xl font-semibold text-amber-900 mb-6" data-id="element-1254">
                How can we help you today?
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1255">
                <div className="bg-amber-50 p-6 rounded-lg border border-amber-200 flex flex-col items-center text-center" data-id="element-1256">
                  <HelpCircleIcon className="h-10 w-10 text-amber-800 mb-4" data-id="element-1257" />
                  <h3 className="font-medium text-lg text-amber-900 mb-2" data-id="element-1258">
                    Frequently Asked Questions
                  </h3>
                  <p className="text-amber-700 mb-4" data-id="element-1259">
                    Find quick answers to common questions about our services.
                  </p>
                  <Link to="/faq" className="mt-auto px-4 py-2 bg-amber-800 text-white rounded hover:bg-amber-900 transition w-full" data-id="element-1260">
                    View FAQs
                  </Link>
                </div>
                <div className="bg-amber-50 p-6 rounded-lg border border-amber-200 flex flex-col items-center text-center" data-id="element-1261">
                  <MessageCircleIcon className="h-10 w-10 text-amber-800 mb-4" data-id="element-1262" />
                  <h3 className="font-medium text-lg text-amber-900 mb-2" data-id="element-1263">
                    Contact Support
                  </h3>
                  <p className="text-amber-700 mb-4" data-id="element-1264">
                    Get in touch with our customer support team for assistance.
                  </p>
                  <Link to="/contact" className="mt-auto px-4 py-2 bg-amber-800 text-white rounded hover:bg-amber-900 transition w-full" data-id="element-1265">
                    Contact Us
                  </Link>
                </div>
                <div className="bg-amber-50 p-6 rounded-lg border border-amber-200 flex flex-col items-center text-center" data-id="element-1266">
                  <FileTextIcon className="h-10 w-10 text-amber-800 mb-4" data-id="element-1267" />
                  <h3 className="font-medium text-lg text-amber-900 mb-2" data-id="element-1268">
                    Policies & Terms
                  </h3>
                  <p className="text-amber-700 mb-4" data-id="element-1269">
                    Review our privacy policy, terms of service, and more.
                  </p>
                  <Link to="/terms" className="mt-auto px-4 py-2 bg-amber-800 text-white rounded hover:bg-amber-900 transition w-full" data-id="element-1270">
                    View Policies
                  </Link>
                </div>
              </div>
            </div>
            <div className="mb-12" data-id="element-1271">
              <h2 className="text-xl font-semibold text-amber-900 mb-6" data-id="element-1272">
                Popular Help Topics
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1273">
                <div className="bg-white p-4 rounded-lg border border-amber-200 hover:bg-amber-50 transition" data-id="element-1274">
                  <Link to="/faq" className="flex items-start" data-id="element-1275">
                    <div className="flex-shrink-0 mt-1" data-id="element-1276">
                      <ClockIcon className="h-5 w-5 text-amber-700" data-id="element-1277" />
                    </div>
                    <div className="ml-4" data-id="element-1278">
                      <h3 className="font-medium text-amber-900" data-id="element-1279">
                        Delivery Times & Coverage
                      </h3>
                      <p className="text-sm text-amber-700" data-id="element-1280">
                        Learn about our delivery areas and estimated delivery
                        times
                      </p>
                    </div>
                  </Link>
                </div>
                <div className="bg-white p-4 rounded-lg border border-amber-200 hover:bg-amber-50 transition" data-id="element-1281">
                  <Link to="/faq" className="flex items-start" data-id="element-1282">
                    <div className="flex-shrink-0 mt-1" data-id="element-1283">
                      <HeartIcon className="h-5 w-5 text-amber-700" data-id="element-1284" />
                    </div>
                    <div className="ml-4" data-id="element-1285">
                      <h3 className="font-medium text-amber-900" data-id="element-1286">
                        Loyalty Program & Rewards
                      </h3>
                      <p className="text-sm text-amber-700" data-id="element-1287">
                        How our points system works and available rewards
                      </p>
                    </div>
                  </Link>
                </div>
                <div className="bg-white p-4 rounded-lg border border-amber-200 hover:bg-amber-50 transition" data-id="element-1288">
                  <Link to="/faq" className="flex items-start" data-id="element-1289">
                    <div className="flex-shrink-0 mt-1" data-id="element-1290">
                      <AlertCircleIcon className="h-5 w-5 text-amber-700" data-id="element-1291" />
                    </div>
                    <div className="ml-4" data-id="element-1292">
                      <h3 className="font-medium text-amber-900" data-id="element-1293">
                        Order Issues & Refunds
                      </h3>
                      <p className="text-sm text-amber-700" data-id="element-1294">
                        What to do if there's a problem with your order
                      </p>
                    </div>
                  </Link>
                </div>
                <div className="bg-white p-4 rounded-lg border border-amber-200 hover:bg-amber-50 transition" data-id="element-1295">
                  <Link to="/faq" className="flex items-start" data-id="element-1296">
                    <div className="flex-shrink-0 mt-1" data-id="element-1297">
                      <ShieldIcon className="h-5 w-5 text-amber-700" data-id="element-1298" />
                    </div>
                    <div className="ml-4" data-id="element-1299">
                      <h3 className="font-medium text-amber-900" data-id="element-1300">
                        Account Security
                      </h3>
                      <p className="text-sm text-amber-700" data-id="element-1301">
                        Tips for keeping your account secure and managing your
                        data
                      </p>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
            <div className="bg-amber-50 p-6 rounded-lg border border-amber-200" data-id="element-1302">
              <h2 className="text-lg font-semibold text-amber-900 mb-4" data-id="element-1303">
                Contact Customer Support
              </h2>
              <div className="space-y-4" data-id="element-1304">
                <div className="flex items-start" data-id="element-1305">
                  <div className="flex-shrink-0 mt-1" data-id="element-1306">
                    <PhoneIcon className="h-5 w-5 text-amber-700" data-id="element-1307" />
                  </div>
                  <div className="ml-4" data-id="element-1308">
                    <h3 className="font-medium text-amber-900" data-id="element-1309">
                      Phone Support
                    </h3>
                    <p className="text-sm text-amber-700" data-id="element-1310">
                      Call us at 09079222970
                    </p>
                    <p className="text-sm text-amber-700" data-id="element-1311">
                      Available daily from 9:00 AM to 10:00 PM
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-1312">
                  <div className="flex-shrink-0 mt-1" data-id="element-1313">
                    <MessageCircleIcon className="h-5 w-5 text-amber-700" data-id="element-1314" />
                  </div>
                  <div className="ml-4" data-id="element-1315">
                    <h3 className="font-medium text-amber-900" data-id="element-1316">
                      Email Support
                    </h3>
                    <p className="text-sm text-amber-700" data-id="element-1317">
                      Send us an email at support@joseskarekare.com
                    </p>
                    <p className="text-sm text-amber-700" data-id="element-1318">
                      We typically respond within 24 hours
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-1319">
                  <div className="flex-shrink-0 mt-1" data-id="element-1320">
                    <ClockIcon className="h-5 w-5 text-amber-700" data-id="element-1321" />
                  </div>
                  <div className="ml-4" data-id="element-1322">
                    <h3 className="font-medium text-amber-900" data-id="element-1323">
                      Support Hours
                    </h3>
                    <p className="text-sm text-amber-700" data-id="element-1324">
                      Phone: Daily, 9:00 AM - 10:00 PM
                    </p>
                    <p className="text-sm text-amber-700" data-id="element-1325">
                      Email: 24/7, response within 24 hours
                    </p>
                    <p className="text-sm text-amber-700" data-id="element-1326">
                      In-Person: During restaurant hours, 10:00 AM - 9:00 PM
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default Help;